import {extractIdFrom, isGoogleDriveImage} from "../utils/Utils";

export const getAsset = (imageUrl: string) => {
    if (isGoogleDriveImage(imageUrl)) {
        return "/api/asset/download/" + extractIdFrom(imageUrl);
    }
    return imageUrl;
};